<div class="wrapper">
  <app-admin-header [pageTitle]="tenantName" [pageSubTitle]="tenantSubName"></app-admin-header>
  <div class="teacher-management-container">
    <div class="toolbar">
      <mat-form-field appearance="outline" class="search-field">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput placeholder="Search teachers..." [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange($event)" />
      </mat-form-field>

      <button mat-stroked-button class="dark-blue" (click)="onBulkUpload()">
        <mat-icon>upload</mat-icon> Bulk Upload
      </button>

      <button mat-flat-button class="dark-blue" (click)="onInviteTeacher()">
        <mat-icon>person_add</mat-icon> Invite Teacher
      </button>
    </div>

    <!-- Department Filter -->
    <div class="department-filter">
      <mat-form-field appearance="outline" class="dept-field">
        <mat-select [(ngModel)]="departmentId" (selectionChange)="onDepartmentChange()">
          <mat-option *ngFor="let dept of departments" [value]="dept.id">
            {{ dept.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Tabs -->
    <mat-tab-group class="custom-tabs" (selectedTabChange)="onTabChange($event)">
      <!-- Active Tab -->
      <mat-tab label="Active">
        <p-table [value]="activeTeachers" class="p-datatable-gridlines responsive-table">
          <ng-template pTemplate="header">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Department</th>
              <th>Role</th>
              <th>Status</th>
              <th>Joined On</th>
              <th>Actions</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-teacher>
            <tr>
              <td>{{ teacher.name }}</td>
              <td>{{ teacher.email }}</td>
              <td>{{ teacher.department }}</td>
              <td>{{ teacher.role }}</td>
              <td>
                <p-tag severity="success" [value]="teacher.status"></p-tag>
              </td>
              <td>{{ teacher.joined }}</td>
              <td>
                <button pButton icon="pi pi-trash" class="p-button-text p-button-danger"
                  (click)="deleteTeacher(teacher)">
                </button>
              </td>
            </tr>
          </ng-template>

          <!-- ✅ No Records Message -->
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7" class="no-records">No active teachers found.</td>
            </tr>
          </ng-template>
        </p-table>
        <p-paginator [rows]="limit" [totalRecords]="totalRecords" [first]="(page - 1) * limit"
          (onPageChange)="onPageChange($event)">
        </p-paginator>

      </mat-tab>

      <!-- Pending Invites Tab -->
      <mat-tab label="Pending Invites">
        <p-table [value]="pendingTeachers" class="p-datatable-gridlines responsive-table">
          <ng-template pTemplate="header">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Department</th>
              <th>Role</th>
              <th>Invited On</th>
              <th>Actions</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-teacher>
            <tr>
              <td>{{ teacher.name }}</td>
              <td>
                <div class="email-cell">
                  <i class="bi bi-envelope"></i>
                  <span>{{ teacher.email }}</span>
                </div>
              </td>
              <td>{{ teacher.department }}</td>
              <td>{{ teacher.role }}</td>
              <td>
                <div class="invited-cell">
                  <i class="bi bi-clock"></i>
                  <span>{{ teacher.joined }}</span>
                </div>
              </td>
              <td>
                <button pButton icon="pi pi-trash" class="p-button-text p-button-danger"
                  (click)="deleteTeacher(teacher)">
                </button>
              </td>
            </tr>
          </ng-template>

          <!-- ✅ No Records Message -->
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="no-records">No pending invites found.</td>
            </tr>
          </ng-template>
        </p-table>
        <p-paginator [rows]="limit" [totalRecords]="totalRecords" [first]="(page - 1) * limit"
          (onPageChange)="onPageChange($event)">
        </p-paginator>

      </mat-tab>

      <!-- By Department Tab -->
      <mat-tab label="By Department">
        <div class="department-summary-grid">
          <div class="dept-card" *ngFor="let dept of departmentSummary">
            <h3>{{ dept.name }}</h3>

            <div class="total-line">
              <span>Total Teachers:</span>
              <span class="count-square">{{ dept.totalTeachers }}</span>
            </div>

            <div class="info-line">
              <span>Active Teachers:</span>
              <span>{{ dept.activeTeachers }}</span>
            </div>

            <div class="info-line">
              <span>Pending Invites:</span>
              <span>{{ dept.pendingInvites }}</span>
            </div>
          </div>

          <div *ngIf="departmentSummary.length === 0" class="no-records">
            No department summary found.
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>